import React, { useEffect, useState, useRef, useCallback } from "react";
import { Pagination } from "@heroui/react";

export default function PaginationComponent({
  page,
  pages,
  onPageChange,
  currentErrors,
}) {
  const [errorPages, setErrorPages] = useState(new Set());
  const paginationRef = useRef(null);

  useEffect(() => {
    const newErrorPages = new Set();

    if (Array.isArray(currentErrors)) {
      currentErrors.forEach((error) => {
        if (
          error.page !== undefined &&
          (!error.productIdCorrected ||
            !error.quantityIdCorrected ||
            !error.variantIdCorrected)
        ) {
          newErrorPages.add(error.page);
        }
      });
    }
    setErrorPages(newErrorPages);
  }, [currentErrors]);

  const applyErrorStyles = useCallback(() => {
    if (paginationRef.current) {
      const children =
        paginationRef.current.querySelectorAll('[role="button"]');

      children.forEach((child) => {
        const pageNum = parseInt(
          child.getAttribute("aria-label").replace("pagination item ", ""),
          10,
        );
        if (errorPages.has(pageNum)) {
          child.style.borderColor = "rgba(254, 129, 88, 1)";
        } else {
          child.style.borderColor = "rgba(18, 24, 38, 0.3)";
        }
      });
    }
  }, [errorPages]);

  useEffect(() => {
    applyErrorStyles();
  }, [errorPages, applyErrorStyles]);

  useEffect(() => {
    applyErrorStyles();
  }, [page, applyErrorStyles]);

  return (
    <div className="bg-[#f0f2f4] sticky top-20 z-50 w-full mr-3">
      <div className="text-center bg-white rounded-t-xl w-full">
        <Pagination
          ref={paginationRef}
          showControls
          classNames={{
            wrapper: "gap-0 h-8 mb-4 text-center mx-auto",
            item: "w-8 h-8 text-small bg-transparent",
            cursor: "bg-vistagreen text-white",
          }}
          color="default"
          page={page}
          total={pages}
          variant="bordered"
          boundaries={4}
          onChange={(newPage) => onPageChange(newPage)}
        />
      </div>
    </div>
  );
}
